<template>
  <div class="edit-card">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-btn :to="{ name: 'profile' }" large text
                ><v-icon left>mdi-chevron-left</v-icon> Profile</v-btn
              >
            </v-col>

            <v-col cols="12" class="d-flex justify-center">
              <v-card max-width="500" width="500" class="pa-5">
                <div class="text-secondary lg mb-5">Update Card</div>

                <v-form>
                  <div v-show="loaded">
                    <div class="subtitle-1 mb-1">Current payment method</div>

                    <div v-if="loaded" class="d-flex justify-space-between">
                      <div>
                        <v-icon>mdi-credit-card-outline</v-icon>
                        <span class="ml-2"> **** **** **** {{ oldCard.last4 }} </span>
                      </div>
                      <div>
                        <span>{{ oldCard.exp_month }} / {{ oldCard.exp_year }}</span>
                        <span class="ml-2">{{ oldCard.zip_code }}</span>
                      </div>
                    </div>

                    <div class="subtitle-1 mt-5">New payment method</div>
                    <div id="card-element" class="mt-1 pt-1 mb-3" />
                    <v-alert v-if="errors.card" dense border="left" type="error" class="mt-2">
                      {{ errors.card[0] }}
                    </v-alert>

                    <div class="text-right">
                      <v-btn type="submit" color="primary" class="mt-5" @click.prevent="submit">
                        Update
                        <v-progress-circular
                          v-if="submitting"
                          size="20"
                          width="2"
                          indeterminate
                          class="ml-2"
                        />
                      </v-btn>
                    </div>
                  </div>

                  <div v-show="loading">
                    <v-skeleton-loader type="list-item-two-line" height="100" />
                    <v-skeleton-loader type="list-item-two-line" height="100" />
                  </div>

                  <div v-show="error">
                    <v-alert dense border="left" type="warning">
                      Unable to communicate with the server. Please check your connection and try
                      again.
                    </v-alert>
                  </div>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Stripe from "@/mixins/Stripe.vue";

export default {
  name: "EditProfileView",
  mixins: [Stripe],
  data() {
    return {
      loaded: false,
      loading: false,
      error: false,
      submitting: false,
      errors: {},
      oldCard: null,
    };
  },
  created() {
    this.loadCard();
  },
  methods: {
    async submit() {
      this.errors = {};
      this.submitting = true;

      const postData = {};

      const result = await this.stripe.createToken(this.card);

      if (result.error) {
        this.submitting = false;
        this.errors.card = [result.error.message];
        return;
      }

      postData.token = result.token.id;

      const responseData = await this.api({
        url: `users/${this.userData.id}/update_card/`,
        method: "POST",
        json: postData,
      });

      this.submitting = false;

      if (responseData.status === 200) {
        location.reload();
      } else {
        this.errors = responseData.body;
      }
    },
    async loadCard() {
      if (this.loading) {
        return;
      }
      this.loading = true;

      const responseData = await this.api({
        url: `users/${this.userData.id}/card/`,
      });

      this.loading = false;

      if (responseData.status === 200) {
        this.loaded = true;
        this.error = false;
        this.oldCard = responseData.body;
      } else {
        this.error = true;
      }
    },
  },
};
</script>
